<script>
  import { Circle2 } from "svelte-loading-spinners";
  import { createEventDispatcher } from "svelte";
  import axios from "axios";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import Modal from "../shared/Modal.svelte";
  import Select from "svelte-select";

  export let _id;
  export let addedOn;
  export let name;
  export let amount;
  export let tel;
  export let role;
  export let currency;

  const numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const removeDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() - days);
    return result.toISOString().slice(0, 10);
  };

  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toISOString().slice(0, 10);
  };

  const getHM = (date) => {
    date = new Date(date);
    let moment = date.toISOString().slice(0, 10);

    if (moment == new Date().toISOString().slice(0, 10)) {
      moment = "aujourd'hui";
    } else if (addDays(moment, 1) == new Date().toISOString().slice(0, 10)) {
      moment = "hier";
    } else {
      moment = new Date(date).toDateString();
    }
    return `${moment} à ${date.getHours()}:${date.getMinutes()}`;
  };

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm("Voulez-vous supprimer");

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/employees/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  // Update A New Pledger-------------------------------------------------------------------
  let editedEmployee = {
    addedOn,
    name,
    amount,
    currency,
    role,
    tel,
  };

  let showEditEmployeeForm = false;
  let updatingEmployee = false;

  const handleUpdate = (e) => {
    updatingEmployee = true;
    axios
      .put(
        `${$config.backendURL}/employees/${_id}`,
        {
          ...editedEmployee,
          currency: editedEmployee.currency.value,
        },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        showEditEmployeeForm = false;
        updatingEmployee = false;
        dispatch("update");
      })
      .catch((err) => {
        updatingEmployee = false;
        console.log(err);
        alert(err);
      });
  };
</script>

<Modal
  show={showEditEmployeeForm}
  on:modalClose={() => {
    showEditEmployeeForm = false;
  }}
>
  <div class="grid gap-y-2">
    <input
      bind:value={editedEmployee.name}
      type="text"
      placeholder="Nom Complet"
      required
    />

    <input
      bind:value={editedEmployee.amount}
      type="number"
      placeholder="Montant"
    />

    <Select
      items={["DOLLARS", "FRANCS"]}
      bind:selectedValue={editedEmployee.currency}
      placeholder="Devise"
    />

    <input
      bind:value={editedEmployee.role}
      type="text"
      placeholder="Fonction"
      required
    />

    <input
      bind:value={editedEmployee.tel}
      type="text"
      placeholder="Telephone"
    />

    {#if updatingEmployee}
      <div class="grid grid-cols-1 gap-8">
        <div class="btn btn-primary">
          <Circle2
            size="25"
            unit="px"
            colorOuter="#F4A261"
            colorCenter="#40B3FF"
            colorInner="#676778"
          />
          <span class="ml-4">Veuillez Patienter...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-primary"
          on:click={handleUpdate}
        >
          <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
          Sauver
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-secondary"
          on:click={(e) => (showEditEmployeeForm = false)}
        >
          <ion-icon name="close-circle" class="text-2xl mr-3" />
          Fermer
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!--  -->
<!--  -->
<div
  class="px-2 pt-2 pb-1 rounded-md shadow-sm bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200"
>
  <div class="">
    <h1
      class="tracking-wider uppercase text-green-600 flex items-center justify-between mb-2"
    >
      <div class="flex items-center">
        <div
          class="bg-green-400 tracking-wider uppercase mr-2 text-sm py-1 px-2 rounded-md shadow-sm text-gray-100"
        >
          {numberWithCommas(amount)}
          {currency == "DOLLARS" ? "$" : "Fc"}
        </div>
        {name}
      </div>
      <div class="flex items-center">
        <button
          on:click={handleDelete}
          class="ml-1 text-red-400 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="trash-bin" />
        </button>
        <button
          on:click={(e) => (showEditEmployeeForm = true)}
          class="ml-1 text-blue-400 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="pencil" />
        </button>
        <button
          on:click={(e) => {
            config.update((prev) => ({
              ...prev,
              full: !$config.full,
            }));
          }}
          class="ml-1 text-gray-600 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="remove" />
        </button>
      </div>
    </h1>

    {#if $config.full}
      <div class="pb-1">
        <div class="flex justify-between">
          <div class="text-sm flex items-center">
            <ion-icon name="call" class="text-xl mr-2" />
            {tel}
          </div>
        </div>
        <div class="mt-2 text-sm text-gray-400">
          {role}.
        </div>
      </div>
    {/if}
  </div>
</div>
